import { ThirdPartyAccountLinkageTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ThirdPartyAccountLinkageTrackingSchema: Record<
  ThirdPartyAccountLinkageTrackingPoint,
  string
> = {
  [ThirdPartyAccountLinkageTrackingPoint.PageView]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyGoogle]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyFacebook]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyApple]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyShopee]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartySuccessAction]: '',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyFailAction]: '',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyPopupView]: '',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyConfirmClick]: '',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyCancelClick]: '',
};

export const getThirdPartyAccountLinkagePageTypeAndSchema = (
  trackingPoint: ThirdPartyAccountLinkageTrackingPoint
) => {
  return {
    page_type: PageType.ThirdPartyAccountLinkagePage,
    schema: ThirdPartyAccountLinkageTrackingSchema[trackingPoint],
  };
};
